import React, { useContext, useState, useEffect } from 'react';
import { Button, Space } from 'antd';
import { CountryContext } from '../../../repository/context/countryContext';
import { UserContext } from '../../../repository/context/userContext';

interface SelectButtonsProps {
  onChangeValue: Function;
}

const SelectButtons = (props: SelectButtonsProps) => {
  const { onChangeValue } = props;
  const countryContext = useContext(CountryContext);
  const userContext = useContext(UserContext);
  const options: any[] = countryContext?.countryList?.map(item => {
    return {
      value: item?.code,
      label: item?.name,
    };
  });

  // Set activeButton based on marketAccess
  const getInitialActiveButton = () => {
    const marketAccess = userContext.user?.marketAccess || null;

    if (marketAccess && options.length > 0) {
      // Parse marketAccess (e.g., "USA,CAN" or "CAN")
      const allowedCodes = marketAccess.split(',').map((code: string) => code.trim());

      // If only one country, find and set it as active
      if (allowedCodes.length === 1) {
        const foundOption = options.find(opt => opt.value === allowedCodes[0]);
        if (foundOption) {
          return foundOption;
        }
      }
    }

    // Default to first option
    return options?.[0];
  };

  const [activeButton, setActiveButton] = useState(getInitialActiveButton());

  // Update activeButton when marketAccess or countryList change
  useEffect(() => {
    const marketAccess = userContext.user?.marketAccess || null;
    const countryList = countryContext?.countryList || [];

    if (marketAccess && countryList.length > 0) {
      const allowedCodes = marketAccess.split(',').map((code: string) => code.trim());

      // If only one country, set it as active
      if (allowedCodes.length === 1) {
        const foundCountry = countryList.find(country => country.code === allowedCodes[0]);
        if (foundCountry) {
          const foundOption = {
            value: foundCountry.code,
            label: foundCountry.name,
          };
          setActiveButton(foundOption);
        }
      }
    }
  }, [userContext.user?.marketAccess, countryContext?.countryList]);

  const handleButtonClick = (item: any) => {
    onChangeValue?.(item.value);
    setActiveButton(item);
  };

  return (
    <Space style={{ margin: '10px 0px' }}>
      {options.map((item, index) => (
        <Button
          key={item.value}
          onClick={() => handleButtonClick(item)}
          style={{
            backgroundColor: activeButton.value === item.value ? 'white' : '#CFD1D4',
            color: 'black',
            borderRadius: '24px',
            fontWeight: 700,
            fontSize: 13,
            padding: '6px 24px',
            height: 'auto',
            border: '1px solid transparent',
          }}
        >
          {item.label}
        </Button>
      ))}
    </Space>
  );
};

export default SelectButtons;
